.d0{outline:none;}